if (!customElements.get('card-product-form')) {
  customElements.define('card-product-form', class CardProductForm extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.selects = Array.from(this.querySelectorAll('select[data-card-option]'));
      this.submitButton = this.querySelector('[data-card-add]');
      this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorWrapper ? this.errorWrapper.querySelector('.product-form__error-message') : null;
      this.spinner = this.querySelector('.loading-overlay__spinner');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      const strings = window.variantStrings || {};
      this.requiredError = this.dataset.errorRequired || 'Please select a variant';
      this.soldOutError = strings.soldOut || 'Sold out';
      this.unavailableError = strings.unavailable || 'Unavailable';

      try {
        const dataEl = this.querySelector('[data-card-variants]');
        this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      } catch (e) {
        this.variants = [];
      }

      this.selects.forEach((select) => select.addEventListener('change', () => this.onOptionChange()));
      if (this.submitButton) this.submitButton.addEventListener('click', (event) => this.onSubmit(event));
    }

    isComplete() {
      return this.selects.every((select) => select.value !== '');
    }

    getMatchedVariant() {
      if (this.selects.length === 0) return this.variants[0];

      return this.variants.find((variant) =>
        Array.isArray(variant.options) &&
        this.selects.every((select) => {
          const index = parseInt(select.dataset.optionIndex, 10);
          return variant.options[index] === select.value;
        })
      );
    }

    onOptionChange() {
      if (this.isComplete()) this.handleErrorMessage();
    }

    onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (!this.isComplete()) {
        this.handleErrorMessage(this.requiredError);
        return;
      }

      const variant = this.getMatchedVariant();
      if (!variant) {
        this.handleErrorMessage(this.unavailableError);
        return;
      }
      if (!variant.available) {
        this.handleErrorMessage(this.soldOutError);
        return;
      }

      this.addToCart(variant.id);
    }

    addToCart(variantId) {
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      if (this.spinner) this.spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'card-product-form',
              productVariantId: variantId,
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'card-product-form', productVariantId: variantId });
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.spinner) this.spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (!this.errorWrapper) return;
      this.errorWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}
